import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Dispatch, bindActionCreators } from 'redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { OrderItemsIDs } from 'Components/OrderItem/Redux/reducer';
import { clearOrderItem, setOrderItemID, setIsInvalidOrderItem } from 'Components/OrderItem/Redux/actions';
import { fetchPerformance } from 'Components/OrderItem/Redux/thunks';
import { fetchVoucherContent } from 'Pages/InfoVoucherPage/Redux/thunks';
import { getPerformance, getIsOrderItemVoucher } from 'Components/OrderItem/Redux/selectors';
import { getVoucherPurchaseImageUrl } from 'Pages/InfoVoucherPage/Redux/selectors';
import OrderItem from 'Components/OrderItem/OrderItem';

interface IPropsInternal {
  isOrderItemVoucher: boolean;
  voucherImageUrl: string;
  performance: Julius.Website.PerformanceOverviewViewModel;
  setOrderItemID: (id: any) => void;
  setIsInvalidOrderItem: () => void;
  fetchPerformance: (id: number) => void;
  fetchVoucherContent: () => void;
  clearOrderItem: () => void;
}

type Props = IPropsInternal & RouteComponentProps<{ orderItemID: string }>;

class OrderItemContainer extends React.PureComponent<Props> {

  componentDidMount() {
    const { orderItemID } = this.props.match.params;
    this.props.setOrderItemID(orderItemID);

    if (orderItemID === OrderItemsIDs.VOUCHER) {
      this.props.fetchVoucherContent();
      return;
    }

    const performanceID = parseInt(orderItemID, 10);

    if (performanceID) {
      this.props.fetchPerformance(performanceID);
    } else {
      this.props.setIsInvalidOrderItem();
    }
  }

  componentWillMount() {
    this.props.clearOrderItem();
  }
  
  render() {
    const { 
      isOrderItemVoucher, voucherImageUrl } = this.props;

    if (isOrderItemVoucher) {
      return (
        <OrderItem
          isOrderItemVoucher={ isOrderItemVoucher }
          imageUrl={ voucherImageUrl }
        />
      );
    }

    const { performance } = this.props;

    if (performance) {
      return (
        <OrderItem 
          isOrderItemVoucher={ isOrderItemVoucher }
          { ... performance }
        />
      );
    }

    return null;
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    performance: getPerformance(state),
    voucherImageUrl: getVoucherPurchaseImageUrl(state),
    isOrderItemVoucher: getIsOrderItemVoucher(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    setOrderItemID,
    setIsInvalidOrderItem,
    fetchPerformance,
    fetchVoucherContent,
    clearOrderItem,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(OrderItemContainer);


// WEBPACK FOOTER //
// ./src/components/OrderItem/OrderItemContainer.tsx